module.exports = __webpack_public_path__ + "static/media/balance-single-leg-stance.f7f21d45.svg";